import React from 'react'

const EcommerceHeaderIconWhite = ({ className, size = 32 }) => {
  return (
    <svg 
      className={className}
      width={size} 
      height={size} 
      viewBox="0 0 32 32" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <filter id="white-glow">
          <feGaussianBlur stdDeviation="2" result="coloredBlur"/>
          <feMerge>
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
      
      <path 
        d="M8 10L6 28C6 29.1046 6.89543 30 8 30H24C25.1046 30 26 29.1046 26 28L24 10H8Z" 
        stroke="#ffffff" 
        strokeWidth="2" 
        fill="none"
        filter="url(#white-glow)"
      />
      
      <path 
        d="M12 10V8C12 5.79086 13.7909 4 16 4C18.2091 4 20 5.79086 20 8V10" 
        stroke="#ffffff" 
        strokeWidth="2" 
        strokeLinecap="round"
        filter="url(#white-glow)"
      />
      
      <rect x="14" y="14" width="8" height="6" rx="1" fill="#ffffff" opacity="0.7"/>
      
      <circle cx="10" cy="7" r="1.5" fill="#ffffff" opacity="0.8"/>
      <circle cx="22" cy="7" r="1" fill="#ffffff" opacity="0.6"/>
      <circle cx="6" cy="13" r="1" fill="#ffffff" opacity="0.6"/>
      <circle cx="26" cy="13" r="1.5" fill="#ffffff" opacity="0.8"/>
    </svg>
  )
}

export default EcommerceHeaderIconWhite
